import React from 'react';
import { View, StyleSheet, Text, Image } from '@react-pdf/renderer';
import { development } from "../libs/utils/Const";
import moment from 'moment';

const stylesTitle = StyleSheet.create({
    tableContainer: {
        width: '97%',
        margin: '15 auto',
    },
    content: {
        flexDirection: 'row',
        display: 'flex',
    },
    col: {
        width: '100%',
    },
    col10: {
        width: '83.3%',
    },
    col8: {
        width: '66.6%',
    },
    col7: {
        width: '58.3%',
    },
    col6: {
        width: '50%',
    },
    col5: {
        width: '41.6%',
    },
    col4: {
        width: '33.3%',
    },
    col3: {
        width: '25%',
    },
    col2: {
        width: '16.6%',
    },
    col1: {
        width: '8.3%',
    },
    logo: {
        width: 130,
        height: 50,
    },
    textLeft: {
        textAlign: 'left',
        paddingTop: '1px',
        fontSize: 9,
    },
    textRight: {
        textAlign: 'right',
        padding: '1px 5px 0px 0px',
        fontSize: 9,
    }
});

const CardTransactionsTitle = ({ header, view, _user }) => (
    <>
        <View style={stylesTitle.tableContainer}>
            <View style={[stylesTitle.content]}>
                <View style={[stylesTitle.col]}>
                    <View style={[stylesTitle.content]}>
                        <View style={[stylesTitle.col6]}>
                            <Image style={stylesTitle.logo} src={development ? require('../images/logo_draft.png') : require('../images/logo_EMPRESA.png')} />
                        </View>
                    </View>
                    <View style={{ alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        <Text style={{ fontSize: 18 }}>Monedero Electrónico {header.Period}</Text>
                    </View>
                    <View style={[stylesTitle.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                        <View style={[stylesTitle.col6, stylesTitle.textLeft]}>
                            <Text>{`SUCURSAL: ${_user?.Sucursal.toUpperCase()} `}</Text>
                            <Text>{_user?.Branch.Address.toUpperCase()}</Text>
                            <Text>{`C.P. ${_user?.Branch.ZipCode || 'Sin código postal'} `}</Text>
                            <Text>{_user?.Branch.Phone || 'Sin número de teléfono'}</Text>
                        </View>
                        <View style={[stylesTitle.col1, stylesTitle.textLeft]}>
                        </View>
                        <View style={[stylesTitle.col5, stylesTitle.textLeft]}>
                            <View style={[stylesTitle.content]}>
                                <View style={[stylesTitle.col7]}>
                                    <Text>Estado de Cuenta</Text>
                                </View>
                            </View>
                            <View style={[stylesTitle.content]}>
                                <View style={[stylesTitle.col7]}>
                                    <Text>Fecha: {moment(new Date()).format('DD-MM-YYYY')}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={[stylesTitle.content, { paddingLeft: '2px', paddingTop: '5px' }]}>
                        <View style={[stylesTitle.col5]}>
                            <View>
                                <Text style={[stylesTitle.textLeft]}>{`Cliente: ${header.CardCode || ""} `}</Text>
                            </View>
                            <View>
                                <Text style={[stylesTitle.textLeft]}>{`Nombre: ${header.CardName || ""} `}</Text>
                            </View>
                            <View >
                                <Text style={[stylesTitle.textLeft]}>{`Dirección: ${header.Address || "S/Dirección"}`}</Text>
                            </View>
                        </View>
                        <View style={[stylesTitle.col7]}>
                            <View style={[stylesTitle.content]}>
                                <View style={[stylesTitle.col4]}>
                                    <View>
                                        <Text style={[stylesTitle.textRight]}>{`RUT: `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[stylesTitle.textRight]}>{`Teléfono: `}</Text>
                                    </View>
                                    <View>
                                        <Text style={[stylesTitle.textRight]}>{`Contacto: `}</Text>
                                    </View>
                                </View>
                                <View style={[stylesTitle.col8]}>
                                    <View>
                                        <Text style={[stylesTitle.textLeft]}>{`${header.LicTradNum || "S/RUT"}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[stylesTitle.textLeft]}>{`${header.Phone1 || "S/N"}`}</Text>
                                    </View>
                                    <View>
                                        <Text style={[stylesTitle.textLeft]}>{`${header.CntntName || "S/Contacto"}`}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={{ alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: 10 }}>
                        <Text style={{ fontSize: 15 }}>Movimientos</Text>
                    </View>
                    <View style={{ alignItems: 'left', width: '100%' }}>
                        <Text style={{ fontSize: 12 }}>Puntos Acumulados: {header.totalPoints}</Text>
                    </View>
                </View>
            </View>
        </View>
    </>
);

const stylesTable = StyleSheet.create({
    tableContainer: {
        width: '97%',
        paddingBottom: 10,
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
      backgroundColor: '#e2e2e2',
      display: 'flex',
      flexDirection: 'row',
    },
    headers: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        flexWrap: 'wrap',
        height: 24
    },
    text:{
      display: 'flex',
      fontSize:'8px',
      alignSelf:'center',
      fontWeight:'300'
    },
    tableRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    cell: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      fontSize:'8px',
      textAlign: 'center',
      paddingTop: '2px',
      paddingLeft: '2px'
      
    },
    date: {
        minWidth: '16.66%',
        maxWidth: '16.66%',
    },
    type: {
        minWidth: '16.66%',
        maxWidth: '16.66%',         
    },
    earned: {
        minWidth: '16.66%',
        maxWidth: '16.66%',
    },
    consumed: {
        minWidth: '16.66%',
        maxWidth: '16.66%',
    },
    folio: {
        minWidth: '16.66%',
        maxWidth: '16.66%',
    },
    amount: {
        minWidth: '16.66%',
        maxWidth: '16.66%',
    },
});

const CardTransactionsTable = ({transactions, header}) => {
    return(
      <View style={stylesTable.tableContainer}> 
        <View style={stylesTable.header} fixed>
          <View style={[stylesTable.headers,stylesTable.date]}>
              <Text style={stylesTable.text}>FECHA</Text>
          </View>
          <View style={[stylesTable.headers,stylesTable.type]}>
              <Text style={stylesTable.text}>TIPO</Text>
          </View>
          <View style={[stylesTable.headers,stylesTable.earned]}>
              <Text style={stylesTable.text}>( + ) PUNTOS</Text>
          </View>
          <View style={[stylesTable.headers,stylesTable.consumed]}>
              <Text style={stylesTable.text}>( - ) PUNTOS</Text>
          </View>
          <View style={[stylesTable.headers,stylesTable.folio]}>
              <Text style={stylesTable.text}>FOLIO</Text>
          </View>
          <View style={[stylesTable.headers,stylesTable.amount]}>
              <Text style={stylesTable.text}>TOTAL</Text>
          </View>
        </View>

        {transactions.map( (transaction, index) => ( 
          <View style={stylesTable.tableRow}>
            <View style={[stylesTable.cell,stylesTable.date]}>
                <Text>{moment(transaction.transaction_date).format('DD-MM-YYYY')}</Text>
            </View>
            <View style={[stylesTable.cell,stylesTable.type]}>
                <Text>{transaction.type}</Text>
            </View>
            <View style={[stylesTable.cell,stylesTable.earned]}>
                <Text>{transaction.points_earned}</Text>
            </View>
            <View style={[stylesTable.cell,stylesTable.consumed]}>
                <Text>{transaction.points_consumed}</Text>
            </View>
            <View style={[stylesTable.cell,stylesTable.folio]}>
                <Text>{transaction.U_FMB_FolioCounter}</Text>
            </View>
            <View style={[stylesTable.cell,stylesTable.amount]}>
                <Text style={{textAlign: 'right', paddingRight: 25}}>{parseFloat(transaction.total_amount).toFixed(2)}</Text>
            </View> 
        </View>
        ))}

        <TableFooter header={header} items = {transactions}/>         
      </View> 
    );
};

const stylesFooter = StyleSheet.create({
    row: {
        flexDirection: 'row',
        display: 'flex',
        height: 15,
        fontSize: 8,
    },
    description: {
        width: '85%',
        textAlign: 'right',
        paddingRight: 8,
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 25,
        backgroundColor: '#e2e2e2',
        fontWeight: 'bold',
    },
});

const TableFooter = ({ header }) => {
    return (
        <View style={{ marginTop:8 }}>
            <View style={stylesFooter.row}>
                <Text style={stylesFooter.description}>Total de Compras</Text>
                <Text style={stylesFooter.total}>{`$ ${Number(header.TotalSpent).toFixed(2)}`}</Text>
            </View>
            <View style={stylesFooter.row}>
                <Text style={stylesFooter.description}>Puntos Obtenidos</Text>
                <Text style={stylesFooter.total}>{Number(header.PointsObtained).toFixed(2)}</Text>
            </View>
            <View style={stylesFooter.row}>
                <Text style={stylesFooter.description}>Puntos Gastados</Text>
                <Text style={stylesFooter.total}>{Number(header.PointsUsed).toFixed(2)}</Text>
            </View>
            <View style={stylesFooter.row}>
                <Text style={stylesFooter.description}>Total de Puntos</Text>
                <Text style={stylesFooter.total}>{Number(header.totalPoints).toFixed(2)}</Text>
            </View>
        </View>
    )
};

export { CardTransactionsTable, CardTransactionsTitle };